// ant design table的排序，搜索功能
import {trim} from "core-js/internals/string-trim";
import {updateTableMixin} from "@/mixins/updateTable";
import {message} from "ant-design-vue";
import {Message} from "element-ui";

export const tableOperationMixin = {

    mixins:[updateTableMixin],
    data() {
        return {
            searchConditionTag: [],//搜索tag
            searchText: '',
            inputSearch: '',
            sortConditionTag: [],
            filteredInfo: null,
            filteredVisible: true,
            tableSearchList: [],
            data: {}
        }
    },
    methods: {
        // 搜索
        handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters, type) {
            var range = type === 'range'
            let time = type === 'time'
            if (range) {
                if (selectedKeys[0] === undefined && selectedKeys[1] === undefined) {
                    return;
                } else if (selectedKeys[0] === undefined) {
                    Message.error('请填写最小值')
                    return;
                } else if (selectedKeys[1] === undefined) {
                    Message.error('请填写最大值')
                    return;
                } else {
                    selectedKeys = selectedKeys.sort((a, b) => {
                        return a - b;
                    });
                }
            }
            if (time) {
                if (selectedKeys[0] === undefined && selectedKeys[1] === undefined) {
                    return;
                } else if (selectedKeys[0] === undefined) {
                    Message.error('请填写开始日期')
                    return;
                } else if (selectedKeys[1] === undefined) {
                    Message.error('请填写结束日期')
                    return;
                } else {
                    selectedKeys = selectedKeys.sort((a, b) => {
                        const dateA = new Date(a);
                        const dateB = new Date(b);
                        return dateA - dateB;
                    });
                }
            }
            let isSearchTag = this.searchConditionTag.map(item => item.key).includes(column.key)
            let length = this.searchConditionTag.length
            if (isSearchTag) {
                this.sortConditionTag.forEach((item, index) => {
                    if (item.key === column.key) {
                        item.value = (time || range) ? selectedKeys.join('至') : selectedKeys[0]
                    }
                })
                let searchIndex = -1
                for (let i = 0; i < length; i++) {
                    if (this.searchConditionTag[i].key === column.key) {
                        if (selectedKeys[0]) {
                            this.searchConditionTag[i].value = (time || range) ? selectedKeys.join('至') : selectedKeys[0]
                            searchIndex = i
                            break
                        }
                    }
                }
                if (searchIndex === -1) {
                    this.searchConditionTag.splice(searchIndex - 1, 1)
                }
            } else {
                //搜索值不为空
                if (selectedKeys[0] !== undefined) {
                    this.searchConditionTag.push({
                        title: column.title,
                        key: column.key,
                        value: (time || range) ? trim(selectedKeys.join('至')) : trim(selectedKeys[0]),
                        clearFilters: clearFilters
                    })
                }
            }
            confirm()
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag
            }
            this.updatePageDataBySearch()
        },
        isPlainObject(v) {
            return Object.prototype.toString.call(v) === '[object Object]';
        },
        handleSearchData(setSelectedKeys, selectedKeys, confirm, column, clearFilters, type,index,option) {
            let columns = column
            let range = type === 'range';
            let time = type === 'time'
            let contractRelatedStatus = type === 'contractRelatedStatus'
            if (range) {
                if (selectedKeys[0] !== undefined && selectedKeys[1] !== undefined) {
                    if (selectedKeys[0] > selectedKeys[1]) {
                        this.$message.error('搜索范围出错，请确保搜索的最大值大于或者等于最小值')
                        return
                    }
                    selectedKeys[0] = selectedKeys[0] + ' 至 ' + selectedKeys[1]
                } else if (selectedKeys[0] === undefined && selectedKeys[1] === undefined) {
                    // 两个都没填
                } else if (selectedKeys[0] === undefined) {
                    //只填了最大值
                    selectedKeys[0] = ' 至 ' + selectedKeys[1]
                } else if (selectedKeys[1] === undefined) {
                    //只填了最小值
                    selectedKeys[0] = selectedKeys[0] + ' 至 '
                }
            }
            if (time) {
                if (selectedKeys[0] === undefined && selectedKeys[1] === undefined) {
                    return;
                } else if (selectedKeys[0] === undefined) {
                    Message.error('请填写开始日期')
                    return;
                } else if (selectedKeys[1] === undefined) {
                    Message.error('请填写结束日期')
                    return;
                } else {
                    selectedKeys = selectedKeys.sort((a, b) => {
                        const dateA = new Date(a);
                        const dateB = new Date(b);
                        return dateA - dateB;
                    });
                }
            }
            if (contractRelatedStatus) {
                const status = option.find(item => item.value === selectedKeys[0])
                if(!status){
                    Message.error('请选择查询状态类型')
                    return;
                }
                if(!selectedKeys[1]){
                    Message.error('请选择查询状态')
                    return;
                }
                columns.title = status.label
                columns.key = status.value
            }
            const isObject = this.isPlainObject(index)
            let info = {}
            if(isObject){
                info = this.data[index.tab].children.find(item => item.name === index.name)
            }else {
                info = this.data[index]
            }
            // copySalesContract.vue 将 searchConditionTag 提升到顶层，其他文件仍在 info 上
            let tagTarget = isObject ? this : info
            let isSearchTag =  tagTarget.searchConditionTag.map(item=>item.key).includes(columns.key)
            let length = tagTarget.searchConditionTag.length
            if (isSearchTag) {
                tagTarget.sortConditionTag.forEach((item,index)=>{
                    if(item.key===columns.key){
                        item.value= time?selectedKeys.join('至'):selectedKeys[0]
                    }
                })
                let searchIndex=-1
                for (let i = 0; i < length; i++) {
                    if(tagTarget.searchConditionTag[i].key===columns.key){
                        if(selectedKeys[0]){
                            tagTarget.searchConditionTag[i].value=time?selectedKeys.join('至'):contractRelatedStatus?trim(selectedKeys[1]):trim(selectedKeys[0])
                            searchIndex=i
                            break
                        }
                    }
                }
                if(searchIndex===-1){
                    tagTarget.searchConditionTag.splice(searchIndex - 1, 1)
                }
            } else {
                //搜索值不为空
                if (selectedKeys[0] !== undefined) {
                    tagTarget.searchConditionTag.push({
                        title: columns.title,
                        key: columns.key,
                        value: time?trim(selectedKeys.join('至')):contractRelatedStatus?trim(selectedKeys[1]):trim(selectedKeys[0]),
                        clearFilters: clearFilters
                    })
                }
            }
            confirm()
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.searchConditionTag = tagTarget.searchConditionTag
            }
            if(isObject){
                this.updateData(index.tab,index.name)
            }else{
                this.updatePageDataBySearch()
            }
        },

        // 删除选择的
        deleteSelect(item, index) {
            if (window.location.search && this.$route && Object.keys(this.$route.query)) {
                this.$router.push(this.$route.path)
            }
            this.searchConditionTag.splice(index, 1)
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.searchConditionTag = this.searchConditionTag
            }
            this.updatePageDataBySearch()
        },
        // 重置
        handleReset(column, clearFilters) {
            clearFilters()
        },
        // table改变时
        changeTable(pagination, filters, sorter) {
            let sortName = ''
            this.sortConditionTag = []
            const elements = document.querySelectorAll('.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on');
            // 遍历每个匹配的元素并移除样式
            elements.forEach(element => {
                element.removeAttribute('style');
            })
            if (sorter) {
                let order = ''
                if (sorter.order) {
                    if (sorter.order === 'ascend') {
                        sortName = '升序'
                        order = 'asc'
                    } else {
                        sortName = '降序'
                        order = 'desc'
                        sorter.order = 'descend'
                    }
                    this.sortConditionTag.push({
                        order: order,
                        colName: sorter.columnKey,
                        title: sorter.column.title,
                        sortName: sortName
                    })
                    if (!this.$refs.searchSortTag) {
                        this.$refs.wMyTable.sortConditionTag = this.sortConditionTag
                    }
                    this.updatePageData()
                }
            }
        },
        // 删除排序
        deleteSort() {
            this.sortConditionTag = []
            const elements = document.querySelectorAll('.ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on');
            // 遍历每个匹配的元素并添加样式
            elements.forEach(element => {
                element.style.color = '#bfbfbf'
            })
            if (!this.$refs.searchSortTag) {
                this.$refs.wMyTable.sortConditionTag = this.sortConditionTag
            }
            this.updatePageData()
        },
    }
}

